import "./About.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";

export default function About() {
  return (
    <section id="about" className="section about-section">
      <div className="about-header">
        <span className="section-tag">{"//"} COORDONNÉES & ACCÈS</span>
        <h2 className="section-title">Notre Siège & Secteur d'Intervention</h2>
        <p className="section-subtitle">
          Implantée à Montigny-le-Bretonneux dans les Yvelines (78), l'équipe WSPS se déploie rapidement sur toute l'Île-de-France.
        </p>
      </div>

      <div className="about-grid">
        {/* Cartes d'informations */}
        <div className="about-info-col">
          <div className="contact-tile">
            <div className="tile-icon"><FaMapMarkerAlt /></div>
            <div>
              <span className="tile-label">Implantation Principale</span>
              <strong>78180 Montigny-le-Bretonneux</strong>
              <p>Yvelines, Île-de-France</p>
            </div>
          </div>

          <div className="contact-tile">
            <div className="tile-icon"><FaPhoneAlt /></div>
            <div>
              <span className="tile-label">Permanence Téléphonique</span>
              <a href="tel:+33602615612" className="tile-link">
                <strong>+33 6 02 61 56 12</strong>
              </a>
              <p>Ligne opérationnelle & astreinte 24/7</p>
            </div>
          </div>

          <div className="contact-tile">
            <div className="tile-icon"><FaEnvelope /></div>
            <div>
              <span className="tile-label">Courriel Commercial & Devis</span>
              <a href="mailto:contact@wsps.fr" className="tile-link">
                <strong>contact@wsps.fr</strong>
              </a>
              <p>Réponse garantie sous 24h ouvrées</p>
            </div>
          </div>

          <div className="contact-tile">
            <div className="tile-icon"><FaClock /></div>
            <div>
              <span className="tile-label">Horaires & Disponibilité</span>
              <strong>Interventions 24h/24 • 7j/7</strong>
              <p>Permanence de garde 365 jours par an</p>
            </div>
          </div>
        </div>

        {/* Google Map intégrée */}
        <div className="about-map-col">
          <div className="map-frame-wrapper">
            <iframe
              title="Localisation WSPS - Montigny-le-Bretonneux"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2636.3300930647594!2d2.0425215159590947!3d48.774116079280226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6886c8a1f9293%3A0x7e957d6a3b36b2c1!2sMontigny-le-Bretonneux!5e0!3m2!1sfr!2sfr!4v1718967891234"
              width="100%"
              height="380"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
